var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs"},[_c('el-tabs',{attrs:{"type":"card"},on:{"tab-click":_vm.handleTabs},model:{value:(_vm.tabs),callback:function ($$v) {_vm.tabs=$$v},expression:"tabs"}},_vm._l((_vm.tabsList),function(item){return _c('el-tab-pane',{key:item.name,attrs:{"label":item.label,"name":item.name}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }